import Layout from "../../components/Layout/Layout";
import SubscriptionMetric from "../../components/CDP/Subscription/SubscriptionMetric";
import MetricsFilter from "../../components/CDP/Subscription/MetricSearch";
import { useSubscriptionFilters } from "./hooks/useSubscriptionFilters";

const DEFAULT_FILTERS = {
  productFilter: "",
  searchTerm: "",
  planFilter: "",
  platformFilter: "",
};

export default function SubscriptionMetrics() {
  const { filters, setFilters, appliedFilters, dateValue, handleApply, handleDateSelect } =
    useSubscriptionFilters(DEFAULT_FILTERS);

  return (
    <Layout>
      <div className="min-h-screen p-6">
        <div className="mx-auto max-w-7xl">
          <MetricsFilter
            onDateSelect={handleDateSelect}
            dateValue={dateValue}
            filters={filters}
            setFilters={setFilters}
            handleApply={handleApply}
          />
          <SubscriptionMetric dateValue={dateValue} filtersdata={appliedFilters} />
        </div>
      </div>
    </Layout>
  );
}
